module.exports = __webpack_public_path__ + "static/media/longwayfromhome.dce98a82.png";